export const booleanize = (string?: string | boolean) => {
  if (typeof string === 'boolean') return string;

  switch (string) {
    case 'true':
      return true;
    case 'false':
      return false;
    default:
      return undefined;
  }
};
